module.exports = __webpack_public_path__ + "3cddff11b74dec9e3a850cb9e4bb66ed.png";